import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'Exo 2', sans-serif;

  input {
    font-family: 'Exo 2', sans-serif;
  }

  p {
    font: 12px 'Exo 2', sans-serif;
  }

  h1 {
    font: 25px 'Exo 2', sans-serif;
  }

  h6 {
    font: 20px 'Exo 2', sans-serif;
    margin-bottom: 25px;
  }

  h2,
  h3,
  h4,
  h5,
  h6,
  label,
  value,
  span {
    font: 14px 'Exo 2', sans-serif;
  }
`;

export const Title = styled.h4`
  display: flex;
  align-items: center;
  margin: 0;
  cursor: pointer;
  padding: 1.7rem 0;

  span {
    margin-left: 0.7rem;
  }
`;
